import { configToUse } from "@/Keycloak";
import axiosInstance from "@/api/axios";

export const submitFeedback = async ({
  chatConversationId,
  data,
}: {
  chatConversationId: string;
  data: { liked: boolean; description: string };
}) => {
  const res = await axiosInstance.put(`/chat/${chatConversationId}/feedback/`, data, {
    baseURL: configToUse.VITE_APP_FERROUS_API_BASE_URL,
  });
  return res.data;
};
